/* Built In Imports */
import { useRouter } from 'next/router';

/* External Imports */
/* Internal Imports */
/* Components */
import { ThankYouErrorScreen } from '@ieo/Components/ThankYou/ThankYouErrorScreen';
import { TakingLongerScreen } from '@ieo/Components/ThankYou/ThankYouTakingLongerScreen';
import { usePageState } from '@ieo/Components/ThankYou/usePageState';

/* Services */

function getErrorMessage(search) {
  const message = search.error || search.errMsg;
  if (message.startsWith('{')) {
    try {
      return JSON?.parse(message).error;
    } catch {
      return message;
    }
  }

  return message;
}

export function ThankYouStatusPage({ messageStatus, bodyData }) {
  const router = useRouter();
  const pageState = usePageState();
  // console.log('pageState', pageState);

  if (messageStatus === 'inprogress' || messageStatus === 'pending') {
    return <TakingLongerScreen />;
  } else if (messageStatus === 'cancelled') {
    return (
      <ThankYouErrorScreen
        message={'Your payment has been cancelled'}
        bodyData={bodyData}
        pageState={pageState}
      />
    );
  } else if (messageStatus === 'error') {
    return (
      <ThankYouErrorScreen
        message={getErrorMessage(router.query)}
        bodyData={bodyData}
        pageState={pageState}
      />
    );
  }
  return null;
}
